import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import touch from 'vue-directive-touch'; // 触摸插件
import  'lib-flexible';
import '@style/app.less';
import '@style/icon-1.less';
import '@style/drawingMap.less';
import $http from '@js/http.js';
import $api from '@js/api/api.js';
import $extend from '@js/deepClone.js'
import { Toast, Image, Lazyload, Dialog } from 'vant'

Dialog.setDefaultOptions({
  'confirmButtonColor':'#4282FF',
})
Toast.setDefaultOptions('loading', { forbidClick: true });
Vue.prototype.$extend = $extend
Vue.prototype.$http = $http;
Vue.prototype.$api = $api;
Vue.use(Lazyload, {
  lazyComponent: true
  // error: errorImage,
  // error: 'http://www.hebeimuseum.org.cn/upload/images/2014/6/619212265.jpg',
  // loading: 'http://www.hebeimuseum.org.cn/upload/images/2014/6/619212265.jpg'
})
  .use(touch)// 触摸插件
  .use(Toast)
  .use(Dialog)
  .use(Image)
Vue.config.productionTip = false;

//  触摸插件说明: https://www.npmjs.com/package/vue-directive-touch
//  vant Ui 官网: https://vant-contrib.gitee.io/vant/#/zh-CN/button
//  axios文档: http://www.axios-js.com/zh-cn/docs/
//  vuerouter: https://router.vuejs.org/zh/


import {
  getOpenId,
} from '@js/url.js';

new Vue({
  router,
  store,
  created() {
    getOpenId();
  },
  render: h => h(App)
}).$mount('#app')
